































































































import { Component, Prop, Vue, Provide } from "vue-property-decorator";
import { OrbitSpinner } from "epic-spinners";
import { getEnv } from "../config";

@Component<Invoice>({
  filters: {
    date: function(value: number) {
      return new Date(value * 1000).toDateString();
    },
  },
  components: {
    OrbitSpinner,
  },
})
export default class Invoice extends Vue {
  private currency = "";
  public loading: boolean = false;

  async created() {
    console.log("created", this.$route.params.invoiceId);

    const result = await fetch(
      `${getEnv().apiEndpoint}${this.$route.params.invoiceId}`
    );
    const invoice = await result.json();

    this.loading = false;

    Object.assign(this, invoice);
  }

  @Prop() private msg!: string;

  formatMoney(amount: number) {
    const currency = this.currency;
    return `${(amount / 100).toFixed(2)} ${currency.toUpperCase()}`;
  }

  data() {
    return {
      loading: true,
      customer: {
        name: "",
        addressLine1: "",
        addressLine2: "",
        zip: "",
        city: "",
        country: "",
        vatId: "",
      },
      number: "",
      date: "",
      charge: {},
      lines: [],
      currency: "USD",
      subtotal: 0,
      tax: 0,
      tax_percent: 0,
      total: 0,
    };
  }
}
